export interface ILayoutConfigParams {
  type: string;
  cancerType?: string;
  clinicalPhase?: string;
  application?: string;
  context?:any[];
  resourceType?: string;
}

export enum LayoutConfigType {
  PanCancerDashboard = 'pan_cancer_dashboard',
  EventsPanel = 'events_panel'
}
